import { resetTimeout } from "."
import moment from "moment"

const INTERVAL = 60 * 1000

export default function executeAt(timestamp, callback, taskId) {
  // eslint-disable-next-line no-console
  console.log(`Task '${taskId}' scheduled to ${moment(timestamp).calendar()}`)
  const handler = () => {
    const timeToUpdate = timestamp - Date.now()
    if (timeToUpdate < INTERVAL) {
      // eslint-disable-next-line no-console
      console.log(
        `Triggering '${taskId}' in ${moment(timeToUpdate).format("mm:ss")}`
      )
      resetTimeout(taskId, callback, timeToUpdate)
    } else {
      resetTimeout(taskId, handler, INTERVAL)
    }
  }
  handler()
}
